import React, { useContext } from 'react';
import { Button, Center, Flex, Heading, Text } from '@chakra-ui/react';
import { useRouter } from 'next/router';
import { AuthStateContext } from '../context/authContext';

interface PageNotFoundProps {
  title?: string;
  description?: string;
  callback?: () => void;
}

function PageNotFound({ callback, title, description }: PageNotFoundProps) {
  const { user } = useContext(AuthStateContext);
  const router = useRouter();

  const goHome = () => {
    callback();
    if (user) {
      router.push(`/${user.access.portal}/#${user.access.resources[0]}/${user.access.languages[0] || 'en'}/`).catch();
    }
  };

  return (
    <Center bg='transparent' h='85vh' color='text.400'>
      <Flex flexDirection='column' textAlign='center'>
        <Heading color='text.600' mb='2'>
          {title || 'Page not found'}
        </Heading>
        <Text fontSize='2xl'>
          {description || (
            <>
              Looks like what you are looking for has moved.
              <br />
              Please check your emails for your updated access.
            </>
          )}
        </Text>
        {callback && (
          <Button colorScheme='brand' onClick={goHome}>
            Go to home page
          </Button>
        )}
      </Flex>
    </Center>
  );
}

export default PageNotFound;
